import React, { useCallback } from 'react';
import { ObjectManager } from '../../../concepts/objects';
import { EmojiData, EmojiPicker } from '../../../ui/emoji';
import { useResolve } from '../../Container';
import { UIField } from '../../canvas/entities/UIField';
import { PopperFieldEditor, PopperFieldEditorContentProps } from '../../canvas/workspace/adapters/PopperFieldEditor';
import { Zone } from './Zone';

const ZoneEmojiPopperContent = ({ field }: PopperFieldEditorContentProps) => {

    const objects = useResolve(ObjectManager);
    const zone = field.owner.cast(Zone);

    const onSelect = useCallback((e: EmojiData) => {
        objects.update(u => {
            u.rolling(UIField.key(field));
            zone.emoji = e.id;
        });
    }, [zone]);

    return <EmojiPicker onSelect={onSelect} />;
};

export const ZoneEmojiField = (owner: Zone): UIField => ({
    ui: PopperFieldEditor(ZoneEmojiPopperContent),
    name: 'emoji',
    bounds: owner.layout.emoji,
    owner,
});
